"use client";
import React from "react";
import Link from "next/link";
import { ArrowUpRight } from "lucide-react";
import { openInNewTab } from "@/lib/utils";
import { Button } from "@/components/ui/button";

type Props = object;

function SomaNavbar({}: Props) {
  return (
    <header className="mx-auto w-full max-w-6xl px-4 py-6 md:px-6 lg:px-8">
      <div className="flex items-center justify-between">
        <Link href="/" className="flex items-center gap-2">
          <span
            className="text-xl font-semibold"
            style={{
              background:
                "linear-gradient(135deg, #FCFCFC 0%, #A0A0A0 50%, #505050 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            PASOMA
          </span>
        </Link>
        <Button
          variant="link"
          className="group flex items-center gap-2 text-zinc-300 transition-colors duration-200 hover:text-white"
          onClick={() =>
            openInNewTab(
              "https://github.com/pasomadev/soma-app/tree/master/docs"
            )
          }
        >
          <span>Documentation</span>
          <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Button>
      </div>
    </header>
  );
}

export default SomaNavbar;
